import { render, staticRenderFns } from "./DocumentCardChanges.vue?vue&type=template&id=6b3af786&"
import script from "./DocumentCardChanges.vue?vue&type=script&lang=js&"
export * from "./DocumentCardChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports